/**
 * A section's action -> bit map.
 *
 * READ IS ALWAYS 2, and every other action takes 2^(index+2) in the order
 * it is listed — so the ORDER of that list is the contract with the
 * backend catalogue, not a formatting choice. Reorder it and existing
 * grants silently point at different actions.
 *
 * THE READ KEY IS A LITERAL HERE, not an import from constants/permissions.
 * That module builds its catalogue with `new PermissionGroup(...)` at
 * module scope, so importing it back creates a cycle: whichever side is
 * evaluated second sees the other half-initialised, and the symptom is
 * `Cannot read properties of undefined (reading 'default')` thrown from
 * whichever screen happened to load first. The constant is one string and
 * PERMISSION_ACTIONS.read is pinned to it by a test.
 */
const READ = 'READ';

interface PermissionGroup {
  [key: string]: number;
}

class PermissionGroup {
  constructor(data: string[] = []) {
    this[READ] = 2;
    data.forEach((key, index) => {
      this[key] = Math.pow(2, index + 2);
    });
  }
}

export default PermissionGroup;
